import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Card } from '../../ui/Card';
interface MoneyOwedToYouStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
export function MoneyOwedToYouStep({
  state,
  updateState
}: MoneyOwedToYouStepProps) {
  return <div className="space-y-6" data-id="element-436">
      <div className="mb-6" data-id="element-437">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-438">
          Money Owed to Me
        </h2>
        <p className="text-gray-600" data-id="element-439">
          If you've lent money to someone and expect to be repaid, or you're
          owed payment for work/sales, include it here. Only include amounts
          you're confident will be repaid.
        </p>
      </div>

      <Card className="space-y-6" data-id="element-440">
        <Input label="Personal Loans Given" prefix="$" type="number" min="0" placeholder="0.00" value={state.loansGiven || ''} onChange={e => updateState({
        loansGiven: parseFloat(e.target.value) || 0
      })} data-id="element-441" />

        <Input label="Expected Payments / Receivables" prefix="$" type="number" min="0" placeholder="0.00" value={state.expectedReceivables || ''} onChange={e => updateState({
        expectedReceivables: parseFloat(e.target.value) || 0
      })} data-id="element-442" />

        <Input label="Security Deposits (Refundable)" prefix="$" type="number" min="0" placeholder="0.00" value={state.securityDeposits || ''} onChange={e => updateState({
        securityDeposits: parseFloat(e.target.value) || 0
      })} data-id="element-443" />
      </Card>
    </div>;
}